import React, { useEffect, useState } from 'react';
import SideMenu from '../components/SideMenu';
import UserMenu from '../components/UserMenu';
import Header from '../components/Header';
import axios from 'axios';
import API_BASE_URL from '../utilities/ApiConfig';
import { toast } from 'react-toastify';
import ApiLoader from '../components/ApiLoader';
import { Table } from '@mui/material';
import TodaysAppointmentsTable from '../components/TodaysAppointmentsTable';


const ImportPde = () => {

    return (

        <>
           
            <div className="flex h-screen">
                <SideMenu />
                <div className="flex-1 flex flex-col">
                    <Header />
                    <div className="flex flex-1">
                        {/* Left Side */}
                        <div className="flex-1 align-middle justify-center">
                              
                             <TodaysAppointmentsTable />
                           

                        </div>


                        {/* Right Side */}
                        <div className="w-64 h-full">
                            <UserMenu />
                        </div>
                    </div>
                </div>
            </div>
        </>




    );
};

export default ImportPde;
